const personRoleStatus = {
    name: "PersonRoleStatus",
    items: {
        ACTIVE: {
            value: 1,
            text: "Active",
            name: "ACTIVE"
        },
        INACTIVE: {
            value: 2,
            text: "Inactive",
            name: "INACTIVE"
        },
        PENDING: {
            value: 0,
            text: "Pending",
            name: "PENDING"
        }
    }
}
export const PersonRoleStatus = personRoleStatus;